import { useEffect, useReducer, useState } from "react";
import "../App.scss";
import Input from "../components/Input/Input";
import axios from "axios";
import Config from "../config";
import SuccessIcon from "../assets/Pathwhite.svg";
import DatePicker from "../components/DatePicker";
import Select from "../components/Select";

const formReducer = (state, actions) => {
  switch (actions.type) {
    case "ADD_VALUE":
      return {
        ...state,
        [actions.id]: { value: actions.value, isValid: actions.isValid },
      };
    case "ADD_ALL":
      return {
        ...actions.value,
      };
    default:
      return { ...state };
  }
};

const Notification = () => {
  const [category, setCategory] = useState({});
  const [hide, setHide] = useState("hide");
  const [activeThresholdCheck, setActiveThresholdCheck] = useState(false);
  const [activeThresholdCategoryCheck, setActiveThresholdCategoryCheck] =
    useState(false);
  const [blockSendingEmailCheck, setBlockSendingEmailCheck] = useState(false);
  const [dailyEmailThresholdLimit, setDailyEmailThresholdLimit] = useState("");
  const urlSearchParam = new URLSearchParams(window.location.search);
  const eSessionId = urlSearchParam.get("eSessionId");
  const parentUrl = urlSearchParam.get("location");
  const [currentValue, setCurrentValue] = useState("");
  const [settingsSubState, setSettingsSubState] = useState("waiting"); // waiting,inprogress,success,failed
  const [configurationSubState, setConfigurationSubState] = useState("waiting"); // waiting,inprogress,success,failed
  const [opsActionSubState, setOpsActionSubState] = useState("waiting"); // waiting,inprogress,success,failed
  const [notificationDashboard, setNotificationDashboard] = useState({});
  const defaultThresholdBreachAction = {
    continue_and_alert: "Continue/Alert Only",
    block_sending_and_enqueue: "Block Sending/Enqueue",
    block_only: "Block Only",
  };
  const pagerDutySet = { true: "Alert", false: "Do Not Alert" };
  const [opsOverride, setOpsOverride] = useState({
    none: "None ",
    send: "Send",
    purge: "Purge",
  });

  const [formState, dispatchForm] = useReducer(formReducer, {
    active: { value: false, isValid: true, isTouched: false },
    category: { value: "", isValid: true, isTouched: false },
    enlemail: { value: "", isValid: true, isTouched: false },
    enlpush: { value: "", isValid: true, isTouched: false },
    enlsms: { value: "", isValid: true, isTouched: false },
    cusemail: { value: "", isValid: true, isTouched: false },
    cuspush: { value: "", isValid: true, isTouched: false },
    cussms: { value: "", isValid: true, isTouched: false },
    site: { value: "", isValid: true, isTouched: false },
    recipient: { value: "", isValid: true, isTouched: false },
    pagerDutySet: { value: "", isValid: true, isTouched: false },
    thresholdBreach: { value: "", isValid: true, isTouched: false },
    opsOverride: { value: "", isValid: true, isTouched: false },
    dailyEmailThresholdLimit: { value: "", isValid: true, isTouched: false },
    start_date: { value: "", isValid: true, isTouched: false },
    end_date: { value: "", isValid: true, isTouched: false },
  });
  // const categoryOption = category.map((cat) => {
  //   return (
  //     <option key={cat.cat_key} value={cat.cat_key}>
  //       {cat.cat_value}
  //     </option>
  //   );
  // });
  // const defaultThresholdBreachActionOption = defaultThresholdBreachAction.map(
  //   (category) => (
  //     <option key={category} value={category}>
  //       {(() => {
  //         switch (category) {
  //           case "continue_and_alert":
  //             return "Continue/Alert Only";
  //           case "block_sending_and_enqueue":
  //             return "Block Sending/Enqueue";
  //           case "block_only":
  //             return "Block Only";
  //           default:
  //             return category;
  //         }
  //       })()}
  //     </option>
  //   )
  // );
  // const pagerDutySetOption = pagerDutySet.map((category) => (
  //   <option key={category} value={category}>
  //     {category == "true" ? "Alert" : "Do not Alert"}
  //   </option>
  // ));
  // const opsOverrideOption = opsOverride.map((category) => (
  //   <option key={category} value={category}>
  //     {(() => {
  //       switch (category) {
  //         case "none":
  //           return "None";
  //         case "purge":
  //           return "Purge";
  //         case "send":
  //           return "Send";
  //         default:
  //           return category;
  //       }
  //     })()}
  //   </option>
  // ));

  const downLoadDoc = (e) => {
    e.preventDefault();
    axios
      .get(
        Config[process.env.REACT_APP_DEPLOYMENT_ENVIRONMENT].MS_URL +
          `/notifications/download?category=${formState.category.value}`,
        {
          headers: {
            "session-id": eSessionId,
          },
          responseType: "blob",
        }
      )
      .then((data) => {
        console.log(data);
        const downloadUrl = window.URL.createObjectURL(
          new Blob([data.data], { type: "application/zip" })
        );
        const link = document.createElement("a");
        link.href = downloadUrl;
        link.setAttribute(
          "download",
          `Emails-${
            notificationDashboard[formState.category.value].email_category_desc
          }.zip`
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const saveNotification = () => {
    axios
      .post(
        Config[process.env.REACT_APP_DEPLOYMENT_ENVIRONMENT].MS_URL +
          "/notification_control_config",
        {
          email_category: formState.category.value,
          email_category_desc:
            notificationDashboard[formState.category.value].email_category_desc,
          daily_enlighten_thresholds: {
            email: formState.enlemail.value,
            sms: formState.enlsms.value,
            push: formState.enlpush.value,
          },
          daily_recipient_thresholds: {
            email: formState.cusemail.value,
            sms: formState.cussms.value,
            push: formState.cuspush.value,
          },
          pager_duty_enabled: formState.pagerDutySet.value,
          default_threshold_breach_action: formState.thresholdBreach.value,
          active: formState.active.value,
        },
        {
          headers: {
            "session-id": eSessionId,
          },
        }
      )
      .then((data) => {
        setConfigurationSubState("success");
        setTimeout(() => {
          setConfigurationSubState("waiting");
        }, 800);
        var obj = {};
        axios
          .get(
            Config[process.env.REACT_APP_DEPLOYMENT_ENVIRONMENT].MS_URL +
              "/notification_control_configs",
            {
              headers: {
                "session-id": eSessionId,
              },
            }
          )
          .then((data) => {
            const RequestedData = data.data;
            RequestedData.forEach((ele) => {
              obj[ele.email_category] = ele;
            });
            setNotificationDashboard(obj);
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
        setConfigurationSubState("failed");
      });
  };

  const saveNotificationOPS = () => {
    axios
      .post(
        Config[process.env.REACT_APP_DEPLOYMENT_ENVIRONMENT].MS_URL +
          "/mail_action",
        {
          ops_action: formState.opsOverride.value,
          email_category: formState.category.value,
          start_date: formState.start_date ? formState.start_date.value : "",
          end_date: formState.end_date ? formState.end_date.value : "",
        },
        {
          headers: {
            "session-id": eSessionId,
          },
        }
      )
      .then((data) => {
        setOpsActionSubState("success");
        setTimeout(() => {
          setOpsActionSubState("waiting");
        }, 800);
        var obj = {};
        axios
          .get(
            Config[process.env.REACT_APP_DEPLOYMENT_ENVIRONMENT].MS_URL +
              "/notification_control_configs",
            {
              headers: {
                "session-id": eSessionId,
              },
            }
          )
          .then((data) => {
            const RequestedData = data.data;
            RequestedData.forEach((ele) => {
              obj[ele.email_category] = ele;
            });
            setNotificationDashboard(obj);
          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        console.log(err);
        setOpsActionSubState("failed");
      });
  };

  const saveNotificationThreshold = () => {
    axios
      .post(
        Config[process.env.REACT_APP_DEPLOYMENT_ENVIRONMENT].MS_URL +
          `/threshold_settings`,
        {
          daily_threshold_limit: dailyEmailThresholdLimit,
          activate_threshold: activeThresholdCheck,
          block_sending_email: blockSendingEmailCheck,
        },
        {
          headers: {
            "session-id": eSessionId,
          },
        }
      )
      .then((data) => {
        setSettingsSubState("success");
        setTimeout(() => {
          setSettingsSubState("waiting");
        }, 800);
      })
      .catch((err) => {
        console.log(err);
        setSettingsSubState("failed");
      });
  };

  const addValue = (id, value) => {
    dispatchForm({ type: "ADD_VALUE", value: value, id: id, isValid: true });
  };

  const resetOpsOverride = (action) => {
    switch (action) {
      case "continue_and_alert":
        setOpsOverride(["None"]);
        addValue("opsOverride", "None");
        break;
      case "block_sending_and_enqueue":
        setOpsOverride(["Purge", "Send"]);
        // addValue(
        //   "opsOverride",
        //   notificationDashboard[formState.category.value].ops_override
        // );
        break;
      case "block_only":
        setOpsOverride(["None"]);
        addValue("opsOverride", "None");
        break;
      default:
        setOpsOverride(["none", "send", "purge"]);
    }
  };

  useEffect(() => {
    axios
      .get(
        Config[process.env.REACT_APP_DEPLOYMENT_ENVIRONMENT].MS_URL +
          "/threshold_settings",
        {
          headers: {
            "session-id": eSessionId,
          },
        }
      )
      .then((data) => {
        const { data: thData } = data || { data: {} };
        setDailyEmailThresholdLimit(
          thData.daily_threshold_limit ? thData.daily_threshold_limit : ""
        );
        setActiveThresholdCheck(
          thData.activate_threshold ? thData.activate_threshold : false
        );
        setBlockSendingEmailCheck(
          thData.block_sending_email ? thData.block_sending_email : false
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    const categories = [];
    var realCategoriesObj = {};
    var obj = {};

    axios
      .get(
        Config[process.env.REACT_APP_DEPLOYMENT_ENVIRONMENT].MS_URL +
          "/notification_control_configs",
        {
          headers: {
            "session-id": eSessionId,
          },
        }
      )
      .then((data) => {
        // const RequestedData = JSON.parse(
        //   '[{"email_category":"envoy_no_report","email_category_desc":"Envoy not reporting","daily_enlighten_thresholds":{"email":5,"push":5,"sms":5,"all":5},"daily_site_thresholds":null,"daily_recipient_thresholds":{"email":5,"push":1,"sms":1,"all":9},"counts_sent": { "email": "7", "sms": "7", "push": "7"},"counts_attempted":null,"pager_duty_enabled":false,"default_threshold_breach_action":null,"ops_override":null,"email_link":null},{"email_category":"device_0w","email_category_desc":"Low Encharge SoC","daily_enlighten_thresholds":{"email":10,"push":10,"sms":10,"all":20},"daily_site_thresholds":null,"daily_recipient_thresholds":{"email":5,"push":1,"sms":1,"all":17},"counts_sent": { "email": "1", "sms": "1", "push": "1"},"counts_attempted":null,"pager_duty_enabled":false,"default_threshold_breach_action":null,"ops_override":null,"email_link":null}]'
        // );

        const RequestedData = data.data;
        RequestedData.forEach((ele) => {
          obj[ele.email_category] = ele;
          realCategoriesObj[ele.email_category] = ele.email_category_desc;
          categories.push({
            cat_key: ele.email_category,
            cat_value: ele.email_category_desc,
          });
          //   realCategories.push(obj);
        });
        var currentVal = categories[0].cat_key;
        setCurrentValue(currentVal);
        setCategory(realCategoriesObj);
        setNotificationDashboard(obj);
        //    resetOpsOverride(obj[currentVal].default_threshold_breach_action);
        var {
          email: enlemail,
          push: enlpush,
          sms: enlsms,
        } = obj[currentVal].daily_enlighten_thresholds || {
          email: "",
          sms: "",
          push: "",
        };
        var {
          email: cusemail,
          push: cuspush,
          sms: cussms,
        } = obj[currentVal].daily_recipient_thresholds || {
          email: "",
          sms: "",
          push: "",
        };
        dispatchForm({
          type: "ADD_ALL",
          value: {
            category: {
              value: categories[0].cat_key,
              isValid: true,
              isTouched: false,
            },
            enlemail: {
              value: enlemail || "",
              isValid: true,
              isTouched: false,
            },
            enlpush: {
              value: enlpush || "",
              isValid: true,
              isTouched: false,
            },
            enlsms: {
              value: enlsms || "",
              isValid: true,
              isTouched: false,
            },
            site: {
              value: cusemail || "",
              isValid: true,
              isTouched: false,
            },
            cusemail: {
              value: cusemail || "",
              isValid: true,
              isTouched: false,
            },
            cuspush: {
              value: cuspush || "",
              isValid: true,
              isTouched: false,
            },
            cussms: {
              value: cussms || "",
              isValid: true,
              isTouched: false,
            },
            // recipient: {
            //   value: obj[currentVal].daily_recipient_thresholds["email"],
            //   isValid: true,
            //   isTouched: false,
            // },
            pagerDutySet: {
              value:
                obj[currentVal].pager_duty_enabled === ""
                  ? ""
                  : obj[currentVal].pager_duty_enabled,
              isValid: true,
              isTouched: false,
            },
            thresholdBreach: {
              value: obj[currentVal].default_threshold_breach_action || "",
              isValid: true,
              isTouched: false,
            },
            opsOverride: {
              value: obj[currentVal].ops_override || "",
              isValid: true,
              isTouched: false,
            },
            dailyEmailThresholdLimit: {
              value: "",
              isValid: true,
              isTouched: false,
            },
            active: {
              value: obj[currentVal].active || false,
              isValid: true,
              isTouched: false,
            },
          },
        });
      })
      .catch((err) => {
        console.log(err);
      });

    //==========================

    // const RequestedData = JSON.parse(
    //   '[{"email_category":"envoy_no_report","email_category_desc":"Envoy not reporting","daily_enlighten_thresholds":{"email":1333,"push":3666,"sms":2,"all":null},"daily_site_thresholds":null,"daily_recipient_thresholds":{"email":1,"push":19,"sms":1,"all":null},"counts_sent":null,"counts_attempted":null,"pager_duty_enabled":false,"default_threshold_breach_action":"block_sending_and_enqueue","ops_override":"send","email_link":null},{"email_category":"device_0w","email_category_desc":"Device produced no power","daily_enlighten_thresholds":{"email":107,"push":10214,"sms":10,"all":null},"daily_site_thresholds":null,"daily_recipient_thresholds":{"email":1,"push":1,"sms":1,"all":null},"counts_sent":null,"counts_attempted":null,"pager_duty_enabled":true,"default_threshold_breach_action":"block_sending_and_enqueue","ops_override":"send","email_link":null},{"email_category":"battery_smart_profile_changes","email_category_desc":"Battery Smart Profile Changes","daily_enlighten_thresholds":{"email":10,"push":10,"sms":10,"all":10},"daily_site_thresholds":null,"daily_recipient_thresholds":{"email":2,"push":2,"sms":2,"all":null},"counts_sent":null,"counts_attempted":null,"pager_duty_enabled":false,"default_threshold_breach_action":"block_sending_and_enqueue","ops_override":"none","email_link":null},{"email_category":"encharge_soc_below_reserve_capacity","email_category_desc":"Encharge SoC below Reserve Capacity","daily_enlighten_thresholds":{"email":10,"push":10,"sms":10,"all":10},"daily_site_thresholds":null,"daily_recipient_thresholds":{"email":2,"push":2,"sms":2,"all":null},"counts_sent":null,"counts_attempted":null,"pager_duty_enabled":false,"default_threshold_breach_action":"block_sending_and_enqueue","ops_override":"none","email_link":null},{"email_category":"ac_voltage_out_of_range","email_category_desc":"AC Voltage Out of Range","daily_enlighten_thresholds":{"email":10,"push":10,"sms":10,"all":10},"daily_site_thresholds":null,"daily_recipient_thresholds":{"email":2,"push":2,"sms":2,"all":null},"counts_sent":null,"counts_attempted":null,"pager_duty_enabled":false,"default_threshold_breach_action":"block_sending_and_enqueue","ops_override":"none","email_link":null}]'
    // );

    // RequestedData.forEach((ele) => {
    //   obj[ele.email_category] = ele;
    //   categories.push({
    //     cat_key: ele.email_category,
    //     cat_value: ele.email_category_desc,
    //   });
    // });
    // var currentVal = categories[0].cat_key;
    // setCurrentValue(currentVal);
    // setCategory(categories);
    // setNotificationDashboard(obj);
    // resetOpsOverride(obj[currentVal].default_threshold_breach_action);
    // dispatchForm({
    //   type: "ADD_ALL",
    //   value: {
    //     category: {
    //       value: categories[0].cat_key,
    //       isValid: true,
    //       isTouched: false,
    //     },
    //     enlemail: {
    //       value: obj[currentVal].daily_enlighten_thresholds["email"],
    //       isValid: true,
    //       isTouched: false,
    //     },
    //     enlpush: {
    //       value: obj[currentVal].daily_enlighten_thresholds["push"],
    //       isValid: true,
    //       isTouched: false,
    //     },
    //     enlsms: {
    //       value: obj[currentVal].daily_enlighten_thresholds["sms"],
    //       isValid: true,
    //       isTouched: false,
    //     },
    //     site: {
    //       value: obj[currentVal].daily_recipient_thresholds["email"],
    //       isValid: true,
    //       isTouched: false,
    //     },
    //     cusemail: {
    //       value: obj[currentVal].daily_recipient_thresholds["email"],
    //       isValid: true,
    //       isTouched: false,
    //     },
    //     cuspush: {
    //       value: obj[currentVal].daily_recipient_thresholds["push"],
    //       isValid: true,
    //       isTouched: false,
    //     },
    //     cussms: {
    //       value: obj[currentVal].daily_recipient_thresholds["sms"],
    //       isValid: true,
    //       isTouched: false,
    //     },
    //     // recipient: {
    //     //   value: obj[currentVal].daily_recipient_thresholds["email"],
    //     //   isValid: true,
    //     //   isTouched: false,
    //     // },
    //     pagerDutySet: {
    //       value: obj[currentVal].pager_duty_enabled,
    //       isValid: true,
    //       isTouched: false,
    //     },
    //     thresholdBreach: {
    //       value: obj[currentVal].default_threshold_breach_action,
    //       isValid: true,
    //       isTouched: false,
    //     },
    //     opsOverride: {
    //       value: obj[currentVal].ops_override,
    //       isValid: true,
    //       isTouched: false,
    //     },
    //   },
    // });

    //======================
  }, [eSessionId]);

  return (
    <div>
      <div className="outerBorder" style={{ marginTop: "0px" }}>
        <div
          className={"borderHeader row"}
          style={{ width: "auto", paddingRight: "17px" }}
        >
          <div className="borderHeader" style={{ paddingLeft: "0px" }}>
            Primary Threshold Settings
          </div>
          {/* <div>
            <a
              href="#"
              style={{ color: "#DF674C", fontSize: "13.5px" }}
              onClick={() => {
                window.top.location = parentUrl + "/admin/email_thresholds/log";
              }}
            >
              Audit Log
            </a>
          </div> */}
        </div>

        <div className={"padding23"}>
          <div className="">
            <div className="mainThresholdSetting">
              <div className="row sectionContent">
                <div>
                  {/* <label style={{ fontSize: "13px", fontWeight: "bold" }}>
                    Block Sending Email
                    <span
                      style={{
                        verticalAlign: "super",
                        fontWeight: "normal",
                      }}
                    >
                      &#10038;
                    </span>{" "}
                    :
                    <input
                      type="checkbox"
                      defaultValue={blockSendingEmailCheck}
                      checked={blockSendingEmailCheck}
                      onChange={() => {
                        setBlockSendingEmailCheck(!blockSendingEmailCheck);
                      }}
                    ></input>
                  </label> */}
                  <div className="row">
                    <div
                      style={{
                        fontSize: "13px",
                        fontWeight: "bold",
                        marginTop: "-5px",
                      }}
                    >
                      Block Sending Email
                      <span
                        style={{
                          verticalAlign: "super",
                          fontWeight: "normal",
                        }}
                      >
                        &#10038;
                      </span>{" "}
                      :
                    </div>
                    <div>
                      {" "}
                      <input
                        type="checkbox"
                        defaultValue={blockSendingEmailCheck}
                        checked={blockSendingEmailCheck}
                        onChange={() => {
                          setBlockSendingEmailCheck(!blockSendingEmailCheck);
                        }}
                      ></input>
                    </div>
                  </div>
                </div>
                <div>
                  {/* <label style={{ fontSize: "13px", fontWeight: "bold" }}>
                    Activate Threshold :
                    <input
                      type="checkbox"
                      defaultValue={activeThresholdCheck}
                      checked={activeThresholdCheck}
                      onChange={() => {
                        setActiveThresholdCheck(!activeThresholdCheck);
                      }}
                    ></input>
                  </label> */}
                  <div className="row" style={{}}>
                    <div style={{ fontSize: "13px", fontWeight: "bold" }}>
                      Activate Threshold :
                    </div>
                    <div>
                      <input
                        type="checkbox"
                        defaultValue={activeThresholdCheck}
                        checked={activeThresholdCheck}
                        onChange={() => {
                          setActiveThresholdCheck(!activeThresholdCheck);
                        }}
                      ></input>
                    </div>
                  </div>
                </div>
                {/* <div>
                  <div className={"sectionHeader"}>Threshold Limit</div>
                  <Input
                    id="dailyEmailThresholdLimit"
                    label="eMail"
                    type="text"
                    value={dailyEmailThresholdLimit}
                    onChange={(val) => {
                      setDailyEmailThresholdLimit(val);
                    }}
                  ></Input>
                </div> */}
                <div>
                  <a
                    href="#"
                    style={{ fontSize: "13.5px", color: "#DF674C" }}
                    onClick={() => {
                      window.top.location =
                        parentUrl + "/admin/email_thresholds/log";
                    }}
                  >
                    Audit Log
                  </a>
                </div>
              </div>
            </div>
            <div className={"row sectionContent"} style={{ marginTop: "0px" }}>
              <div style={{ fontStyle: "italic" }}>
                <strong>Note</strong>
                <span style={{ verticalAlign: "super" }}>&#10038;</span>:By
                checking block sending email feature, Enlighten will not send
                any emails. <strong>Except</strong>: monthly_report,
                email_password_reset, forgot_email, forgot_email_unique_account,
                reimbursement_request, profile_workflow_status
              </div>
              <div>
                {/* <input
                  type="submit"
                  value="Save"
                  onClick={() => {
                    setHide("");
                    saveNotificationThreshold();
                  }}
                ></input> */}

                <button
                  disabled={settingsSubState == "inprogress"}
                  className={`${
                    settingsSubState == "inprogress" ? "inprogress" : ""
                  }${settingsSubState == "success" ? "success" : ""}`}
                  onClick={() => {
                    setSettingsSubState("inprogress");
                    saveNotificationThreshold();
                  }}
                >
                  {settingsSubState == "inprogress" ? (
                    <div className="spinner"></div>
                  ) : (
                    ""
                  )}
                  {settingsSubState == "success" ? (
                    <img src={SuccessIcon} alt="SuccessIcon" />
                  ) : null}
                  {settingsSubState == "inprogress"
                    ? "Processing..."
                    : settingsSubState == "success"
                    ? ""
                    : "Save"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="outerBorder">
        <div className={"borderHeader"}>Fine Grained Thresholds</div>
        <div
          style={{
            paddingLeft: "20px",
            paddingTop: "20px",
            paddingBottom: "10px",
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
          }}
        >
          <div>
            <div className={"sectionHeader"} style={{ fontSize: "16px" }}>
              Category
            </div>
            <div className={"sectionContent"}>
              <Select
                containerStyles={{ width: "250px" }}
                limitCharacter={30}
                onChange={(e) => {
                  setCurrentValue(e.target.value);
                  //     debugger;
                  var {
                    email: enlemail,
                    push: enlpush,
                    sms: enlsms,
                  } = notificationDashboard[e.target.value]
                    .daily_enlighten_thresholds || {
                    email: "",
                    sms: "",
                    push: "",
                  };
                  var {
                    email: cusemail,
                    push: cuspush,
                    sms: cussms,
                  } = notificationDashboard[e.target.value]
                    .daily_recipient_thresholds || {
                    email: "",
                    sms: "",
                    push: "",
                  };

                  dispatchForm({
                    type: "ADD_ALL",
                    value: {
                      category: {
                        value: e.target.value || "",
                        isValid: true,
                        isTouched: false,
                      },
                      enlemail: {
                        value: enlemail || "",
                        isValid: true,
                        isTouched: false,
                      },
                      enlpush: {
                        value: enlpush || "",
                        isValid: true,
                        isTouched: false,
                      },
                      enlsms: {
                        value: enlsms || "",
                        isValid: true,
                        isTouched: false,
                      },
                      site: {
                        value: cusemail || "",
                        isValid: true,
                        isTouched: false,
                      },
                      cusemail: {
                        value: cusemail || "",
                        isValid: true,
                        isTouched: false,
                      },
                      cuspush: {
                        value: cuspush || "",
                        isValid: true,
                        isTouched: false,
                      },
                      cussms: {
                        value: cussms || "",
                        isValid: true,
                        isTouched: false,
                      },
                      // recipient: {
                      //   value:
                      //     notificationDashboard[e.target.value]
                      //       .daily_recipient_thresholds["email"],
                      //   isValid: true,
                      //   isTouched: false,
                      // },
                      pagerDutySet: {
                        value:
                          notificationDashboard[e.target.value]
                            .pager_duty_enabled === ""
                            ? ""
                            : notificationDashboard[e.target.value]
                                .pager_duty_enabled,
                        isValid: true,
                        isTouched: false,
                      },
                      thresholdBreach: {
                        value:
                          notificationDashboard[e.target.value]
                            .default_threshold_breach_action || "",
                        isValid: true,
                        isTouched: false,
                      },
                      opsOverride: {
                        value:
                          notificationDashboard[e.target.value].ops_override ||
                          "",
                        isValid: true,
                        isTouched: false,
                      },
                      active: {
                        value:
                          notificationDashboard[e.target.value].active || false,
                        isValid: true,
                        isTouched: false,
                      },
                    },
                  });
                }}
                value={formState.category.value}
                options={category}
              ></Select>
              {/* <Select
              options={{}}
              value=""
              onChange={(e) => {
                console.log("value selected", e.target.value);
              }}
              containerStyles={{ width: "250px" }}
            ></Select> */}
            </div>
          </div>
          <div
            className="row"
            style={{
              justifyContent: "flex-start",
              marginLeft: "210px",
              marginTop: "25px",
            }}
          >
            <div style={{ fontSize: "13px", fontWeight: "bold" }}>
              Activate Category Threshold :
            </div>
            <div>
              <input
                type="checkbox"
                defaultValue={formState.active.value}
                checked={formState.active.value}
                onChange={() => {
                  addValue("active", !formState.active.value);
                  //   setActiveThresholdCategoryCheck();
                }}
              ></input>
            </div>
          </div>
        </div>

        <div className="row flexStartAlign">
          <div
            className={"padding23 boxShadow padding10 margin10"}
            style={{ width: "70%" }}
          >
            <div
              className="opsCategory"
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginRight: "10px",
              }}
            >
              <div style={{ color: "#f37320" }}>Configurations</div>
              <div>
                <p style={{ fontSize: "9px", color: "grey" }}>
                  If no limit set of Email , SMS or Push option , system will
                  not impose any threshold limit
                </p>
              </div>
            </div>
            <div className="header col" style={{ alignItems: "flex-start" }}>
              <div className={"row"} style={{ marginTop: "25px" }}>
                <div style={{ width: "100%" }}>
                  <div className={"sectionHeader"}>
                    Threshold at Enlighten(Per day)
                  </div>
                  <div className={"row sectionContent"}>
                    <div style={{}}>
                      <Input
                        id="enlemail"
                        label="eMail"
                        type="text"
                        value={formState.enlemail.value}
                        onChange={(val) => {
                          const re = /^[0-9\b]+$/;
                          if (val === "" || re.test(val)) {
                            addValue("enlemail", val);
                          }
                        }}
                      ></Input>
                    </div>
                    <div style={{}}>
                      <Input
                        id="enlpush"
                        label="Push"
                        value={formState.enlpush.value}
                        onChange={(val) => {
                          const re = /^[0-9\b]+$/;
                          if (val === "" || re.test(val)) {
                            addValue("enlpush", val);
                          }
                        }}
                      ></Input>
                    </div>
                    <div style={{}}>
                      <Input
                        id="enlsms"
                        label="SMS"
                        value={formState.enlsms.value}
                        onChange={(val) => {
                          const re = /^[0-9\b]+$/;
                          if (val === "" || re.test(val)) {
                            addValue("enlsms", val);
                          }
                        }}
                      ></Input>
                    </div>
                  </div>
                </div>
                {/* <div
              className="row"
              style={{ width: "30%", justifyContent: "flex-end" }}
            >
              <div className={"col"} style={{ alignItems: "flex-start" }}>
                <div className={"sectionHeader"}>
                  Threshold at Customer(Per day)
                </div>
                <div
                  className={"row sectionContent"}
                  style={{ justifyContent: "flex-start" }}
                >
                  <div style={{}}>
                    <Input
                      id="recipient"
                      label="Recipient"
                      value={formState.recipient.value}
                      onChange={(val) => {
                        addValue("recipient", val);
                      }}
                    ></Input>
                  </div>
                </div>
              </div>
            </div> */}
              </div>

              <div className={"row"} style={{ marginTop: "25px" }}>
                <div style={{ width: "100%" }}>
                  <div className={"sectionHeader"}>
                    Threshold at Customer/Site(Per day)
                  </div>
                  <div className={"row sectionContent"}>
                    <div style={{}}>
                      <Input
                        id="cusemail"
                        label="eMail"
                        type="text"
                        value={formState.cusemail.value}
                        onChange={(val) => {
                          const re = /^[0-9\b]+$/;
                          if (val === "" || re.test(val)) {
                            addValue("cusemail", val);
                          }
                        }}
                      ></Input>
                    </div>
                    <div style={{}}>
                      <Input
                        id="cuspush"
                        label="Push"
                        value={formState.cuspush.value}
                        onChange={(val) => {
                          const re = /^[0-9\b]+$/;
                          if (val === "" || re.test(val)) {
                            addValue("cuspush", val);
                          }
                        }}
                      ></Input>
                    </div>
                    <div style={{}}>
                      <Input
                        id="cussms"
                        label="SMS"
                        value={formState.cussms.value}
                        onChange={(val) => {
                          const re = /^[0-9\b]+$/;
                          if (val === "" || re.test(val)) {
                            addValue("cussms", val);
                          }
                        }}
                      ></Input>
                    </div>
                  </div>
                </div>
              </div>

              <div
                className={"row"}
                style={{ marginTop: "30px", width: "100%" }}
              >
                <div>
                  <div className={"sectionHeader"}>Pager Duty Set</div>
                  <div className={"sectionContent"}>
                    <Select
                      containerStyles={{ width: "189px" }}
                      onChange={(e) => {
                        addValue("pagerDutySet", e.target.value);
                      }}
                      value={formState.pagerDutySet.value}
                      options={pagerDutySet}
                    >
                      {/* {pagerDutySetOption} */}
                    </Select>

                    {/* <Multiselect
                  options={[
                    { name: "Srigar", id: 1 },
                    { name: "Sam", id: 2 },
                  ]} // Options to display in the dropdown
                  showCheckbox={true}
                  showArrow={true}
                  singleSelect={true}
                  closeOnSelect={false}
                  style={{
                    chips: {
                      // To change css chips(Selected options)
                      background: "red",
                    },
                    option: {
                      // To change css for dropdown options
                      color: "yellow",
                    },
                  }}
                  placeholder="Selectr values"
                  displayValue="name" // Property name to display in the dropdown options
                /> */}
                  </div>
                </div>
                <div>
                  <div className={"sectionHeader"}>Threshold Action</div>
                  <div className={"sectionContent"}>
                    <Select
                      containerStyles={{ width: "189px" }}
                      onChange={(e) => {
                        //          resetOpsOverride(e.target.value);
                        addValue("thresholdBreach", e.target.value);
                      }}
                      value={formState.thresholdBreach.value}
                      options={defaultThresholdBreachAction}
                    >
                      {/* {defaultThresholdBreachActionOption} */}
                    </Select>
                  </div>
                </div>
                <div style={{ visibility: "hidden", width: "191px" }}></div>
              </div>

              <div
                className={"row sectionContent"}
                style={{ justifyContent: "flex-end", marginTop: "0px" }}
              >
                <div style={{ marginRight: "50px" }}>
                  <a
                    style={{ fontSize: "13.5px", color: "#DF674C" }}
                    href="#"
                    onClick={downLoadDoc}
                  >
                    Download
                  </a>
                </div>
                <div>
                  {/* <input
                    type="submit"
                    value="Save"
                    onClick={() => {
                      setHide("");
                      saveNotification();
                    }}
                  ></input> */}

                  <button
                    disabled={configurationSubState == "inprogress"}
                    className={`${
                      configurationSubState == "inprogress" ? "inprogress" : ""
                    }
                    ${configurationSubState == "success" ? "success" : ""}`}
                    onClick={() => {
                      setConfigurationSubState("inprogress");
                      saveNotification();
                    }}
                  >
                    {configurationSubState == "inprogress" ? (
                      <div className="spinner"></div>
                    ) : (
                      ""
                    )}

                    {configurationSubState == "success" ? (
                      <img src={SuccessIcon} alt="SuccessIcon" />
                    ) : null}
                    {configurationSubState == "inprogress"
                      ? "Processing..."
                      : configurationSubState == "success"
                      ? ""
                      : "Save"}
                  </button>
                </div>
              </div>
            </div>
            <div></div>
          </div>
          <div
            className="padding23 boxShadow padding10 margin10"
            style={{
              width: "30%",
              height: "362px",
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <div>
              <div className="opsCategory">OPS Action</div>

              <div className={"sectionHeader"} style={{ marginTop: "25px" }}>
                OPS Action
              </div>
              <div className={"row sectionContent"}>
                <Select
                  containerStyles={{ width: "189px" }}
                  onChange={(e) => {
                    addValue("opsOverride", e.target.value);
                  }}
                  value={formState.opsOverride.value}
                  options={opsOverride}
                >
                  {/* {opsOverrideOption} */}
                </Select>
              </div>
            </div>

            <div
              className={"row"}
              style={{ marginTop: "36.5px", width: "100%" }}
            >
              <div>
                <div
                  className={"sectionHeader"}
                  style={{ marginBottom: "-1px" }}
                >
                  Start Date
                </div>

                {/* <input
                    style={{ color: "white" }}
                    type="date"
                    className="datePick"
                    onClick={(e) => (e.target.style.color = "black")}
                  ></input> */}

                <DatePicker
                  name="start_date"
                  onChange={(date, mm, dd, yyyy) => {
                    addValue("start_date", `${yyyy}-${mm}-${dd}`);
                  }}
                  containerClassName="datepicker-container"
                  placeholder="mm/dd/yyyy"
                />
              </div>
              <div style={{ visibility: "hidden", width: "191px" }}></div>
              <div style={{ visibility: "hidden", width: "191px" }}></div>
            </div>

            <div
              className={"row"}
              style={{ marginTop: "52.5px", width: "100%" }}
            >
              <div>
                <div
                  className={"sectionHeader"}
                  style={{ marginBottom: "-1px" }}
                >
                  End Date
                </div>
                <DatePicker
                  name="end_date"
                  onChange={(date, mm, dd, yyyy) => {
                    addValue("end_date", `${yyyy}-${mm}-${dd}`);
                  }}
                  containerClassName="datepicker-container"
                  placeholder="mm/dd/yyyy"
                />
              </div>
              <div style={{ visibility: "hidden", width: "191px" }}></div>
              <div style={{ visibility: "hidden", width: "191px" }}></div>
            </div>

            <div
              className={`row sectionContent`}
              style={{ justifyContent: "flex-end", marginTop: "0px" }}
            >
              <div>
                <button
                  disabled={
                    opsActionSubState == "inprogress" ||
                    formState.opsOverride.value == "none"
                  }
                  className={`${
                    opsActionSubState == "inprogress" ? "inprogress" : ""
                  }${opsActionSubState == "success" ? "success" : ""}${
                    formState.opsOverride.value == "none" ? "inprogress" : ""
                  }`}
                  onClick={() => {
                    setOpsActionSubState("inprogress");
                    saveNotificationOPS();
                  }}
                >
                  {opsActionSubState == "inprogress" ? (
                    <div className="spinner"></div>
                  ) : (
                    ""
                  )}

                  {opsActionSubState == "success" ? (
                    <img src={SuccessIcon} alt="SuccessIcon" />
                  ) : null}
                  {opsActionSubState == "inprogress"
                    ? "Processing..."
                    : opsActionSubState == "success"
                    ? ""
                    : "Apply"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="outerBorder">
        <div className={"borderHeader"}> Today's Statistics</div>
        <div className="row1 padding23">
          {/* <div className={"sectionHeader"} style={{ width: "20%" }}>
          Today's Statistics
        </div> */}
          <div
            className={" row sectionContent"}
            style={{ width: "40%", marginTop: "16px" }}
          >
            <div style={{ border: "1px solid rgba(#707070, 0.12)" }}>
              Email :{" "}
              {notificationDashboard &&
              notificationDashboard[currentValue] &&
              notificationDashboard[currentValue].counts_sent &&
              notificationDashboard[currentValue].counts_sent.email
                ? notificationDashboard[currentValue].counts_sent.email
                : 0}
            </div>
            <div>
              Push :{" "}
              {notificationDashboard &&
              notificationDashboard[currentValue] &&
              notificationDashboard[currentValue].counts_sent &&
              notificationDashboard[currentValue].counts_sent.push
                ? notificationDashboard[currentValue].counts_sent.push
                : 0}
            </div>
            <div>
              SMS :{" "}
              {notificationDashboard &&
              notificationDashboard[currentValue] &&
              notificationDashboard[currentValue].counts_sent &&
              notificationDashboard[currentValue].counts_sent.sms
                ? notificationDashboard[currentValue].counts_sent.sms
                : 0}
            </div>
          </div>
        </div>
      </div>
      {/* <div className={`popup }`}>Success</div> */}
      {/* <div className={`greyBack `}></div> */}
    </div>
  );
};

export default Notification;
